import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'initiative-media',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './initiative-media.component.html',
  styleUrl: './initiative-media.component.scss',
})
export class InitiativeMediaComponent {
  images = [
    {
      imgUrl: '../../../../assets/images/csr_journal.svg',
      alt: 'The CSR Journal',
      link_url:
        'https://thecsrjournal.in/corporate-social-responsibility-csr-news-am-ns-india-inaugurates-ai-enabled-digital-classroom-at-government-primary-school-in-kawas/',
    },
    {
      imgUrl: '../../../../assets/images/observenow-logo-full.webp',
      alt: 'Observe Now',
      link_url:
        'https://observenow.com/2024/10/am-ns-india-inaugurates-ai-enabled-digital-classroom-at-government-primary-school-in-kawas/',
    },
    {
      imgUrl: '../../../../assets/images/apac_media.webp',
      alt: 'APAC Media',
      link_url:
        'https://apacnewsnetwork.com/2024/10/arcelormittal-nippon-steel-launches-ai-enabled-classroom-at-kawas-village-school-near-surat/',
    },
    {
      imgUrl: '../../../../assets/images/ETR.svg',
      alt: 'ETR',
      link_url:
        'https://www.edtechreview.in/news/am-ns-india-unveils-ai-enabled-digital-classroom-to-enhance-rural-education/#:~:text=By%20empowering%20them%20with%20the,purposeful%2C%20inclusive%2C%20and%20sustainable',
    },
    {
      imgUrl: '../../../../assets/images/india-csr-network-seeklogo.svg',
      alt: 'India CSR Network',
      link_url:
        'https://indiacsr.in/am-ns-india-launches-ai-enabled-digital-classroom-kawas/',
    },
  ];
}
